import React from 'react';
import {ILauncherServiceFactory} from '../../launcher-service-factory.interface';

export interface ConfigFieldDependencies {
    configurationKey: string;
    services: ILauncherServiceFactory
}

export interface IConfigFieldDefinition {
    readonly configurationKey: string;
    readonly title: string;
    readonly description: string;
    getValue(): any;
    setValue(value: any): void;
    resetToDefault(): void;
    render(): React.ReactNode;
}

export abstract class ConfigFieldDefinitionBase implements IConfigFieldDefinition {

    constructor(private _title: string, private _description: string = '') {

    }


    abstract render(): React.ReactNode;

    get title(): string {
        return this._title;
    }
    get description(): string {
        return this._description;
    }

    private _dependencies: ConfigFieldDependencies;
    injectDependencies(dependencies: ConfigFieldDependencies): void {
        this._dependencies = dependencies;
    }

    get configurationKey(): string {
        return this._dependencies.configurationKey;
    }

    protected get services(): ILauncherServiceFactory {
        return this._dependencies.services;
    }

    getValue(): any {
        return this.services.configsStorage.getValue(this.configurationKey);
    }

    setValue(value: any): void {
        this.services.configsStorage.updateValue(this.configurationKey, value);
    }

    resetToDefault(): void {
        this.services.configsStorage.resetToDefault(this.configurationKey);
    }

}